import React from 'react';
import { Button } from 'antd';
import { TAssetInput } from '@src/types/add-to-scene-modal';
import { ASSET_TYPE } from '../react-three-components/sceneAsset';
import styles from './shaders-content.module.css';

interface ShadersContentProps {
  onAddToScene: (assetData: TAssetInput) => void;
}

export default function ShadersContent({ onAddToScene }: ShadersContentProps) {
  const handleAddWaterShader = () => {
    onAddToScene({
      type: ASSET_TYPE.SHADER.WATER,
      name: 'Water Shader',
      url: '',
      ref: React.createRef(),
      metadata: {
        shaderParams: {
          wavesAmplitude: 0.025,
          wavesFrequency: 1.07,
          wavesPersistence: 0.3,
          wavesLacunarity: 2.18,
          wavesIterations: 8,
          wavesSpeed: 0.4,
          opacity: 0.8,
          troughColor: '#186691',
          surfaceColor: '#9bd8c0',
          peakColor: '#bbd8e0',
          peakThreshold: 0.08,
          peakTransition: 0.05,
          troughThreshold: -0.01,
          troughTransition: 0.15,
          fresnelScale: 0.8,
          fresnelPower: 0.5,
        },
      },
    });
  };

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.infoSection}>
        <h3>Shaders</h3>
        <p>
          Add advanced shader effects to your scene. Shaders provide realistic
          visual effects like water surfaces, animated materials, and more.
        </p>
      </div>
      <div className={styles.shadersGrid}>
        <div className={styles.shaderCard}>
          <div className={styles.shaderPreview}>
            <img
              src='https://d23hwblhugcea5.cloudfront.net/studioAssets/imageAssets/WaterShader.jpg'
              alt='Water Shader Preview'
              className={styles.shaderImage}
              onError={(e) => {
                console.error('Error loading water shader preview image:', e);
                e.currentTarget.style.display = 'none';
              }}
            />
          </div>
          <div className={styles.shaderInfo}>
            <h4>Water Shader</h4>
            <p>Realistic animated water surface with waves and reflections</p>
            <Button type='primary' onClick={handleAddWaterShader}>
              Add Water
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
